import dynamic from "next/dynamic";
import PageContainer from "@/components/page-comtainer";
// import Home from './home';
import HomeMobile from "./home-mobile";
import Head from "next/head";
import {getProductImage} from "@/utils/utils";
import React from "react";
const Home = dynamic(() => import("@/pages/beta"), {
  ssr: false, // 如果组件只在客户端渲染，可以设置为 false
  loading: () => <div></div>, // 可选：提供一个加载状态
});

export async function getServerSideProps(context) {
  const userAgent = context.req.headers['user-agent'] || '';
  const isH5 = /Android|webOS|iPhone|iPod|BlackBerry/i.test(userAgent);
  return { props: { isH5 } };
}
const NewHome = ({ isH5 }) => {

  return <>
    <Head>
      <title>anyStarr</title>
      <meta name='description' content={"As an official TikTok affiliate partner, anyStarr empowers creators to maximize their earnings with higher commissions, an extensive selection of high-quality products, and dedicated support for long-term success. Join anyStarr today and turn your TikTok influence into real revenue!"} />
      <meta property='og:type' content='product' />
      <meta property='og:title' content={"anyStarr"} />
      <meta property='og:description' content={"As an official TikTok affiliate partner, anyStarr empowers creators to maximize their earnings with higher commissions, an extensive selection of high-quality products, and dedicated support for long-term success. Join anyStarr today and turn your TikTok influence into real revenue!"} />
      <meta property='og:url' content={`https://anystarr.com`} />
      <meta property='og:site_name' content='anyStarr' />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={"anyStarr"} />
      <meta name='twitter:description' content={"As an official TikTok affiliate partner, anyStarr empowers creators to maximize their earnings with higher commissions, an extensive selection of high-quality products, and dedicated support for long-term success. Join anyStarr today and turn your TikTok influence into real revenue!"} />
    </Head>
    <PageContainer pc={<div className={"min-h-[500px]"}>
      <Home />
    </div>} h5={<HomeMobile />} isH5={isH5} />
  </>;
  // return <Home />;
};

export default NewHome;
